import React from 'react';

import IncentiveRp from 'components/Tvendo/Commissions/Operations/Incentive/Reports/IncentiveRp.js';

export default function () {
  return <IncentiveRp />;
}
